var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_c('a',{staticClass:"text-blue-500 underline",attrs:{"href":_vm.params.value.Link,"target":"_blank"}},[_vm._v(" $"+_vm._s(_vm.params.value.Price)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }